import _ from 'lodash';
import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../../../actions/actions';

// selectors
import { getFirstPageWithEmptyResults } from './../../../selectors/selectors';

class PagesCounter extends React.Component {
    constructor(props) {
        super(props);
        this.calcProgressBar = this.calcProgressBar.bind(this);
    }

    onStepsClick(pageId, e) {
        this.props.actions.setActivePage(pageId);
    }

    calcProgressBar() {
        const pagePercentage = 100 / this.props.pagesList.length;
        const activePageIndex = (this.props.pagesList.indexOf(this.props.activeId)) + 1;

        const activePercantage = pagePercentage * activePageIndex;
        
        return {
            height: `${activePercantage}%`,
        };
    }

    render() {
        const { mode, results, activeId, pagesList, firstEmptyPage } = this.props;
        const indexOfEmptyPage = _.indexOf(pagesList, firstEmptyPage);

        const list = pagesList.map((pageId, index) => {
            if (pageId === _.last(pagesList)) {
                return null;
            }

            if (index > indexOfEmptyPage && indexOfEmptyPage !== -1 && mode === 'CLIENT') {
                return <li key={pageId} className="steps__item steps-disabled">{index}</li>;
            }

            return <li key={pageId} className={(activeId === pageId) ? 'steps__item is-active' : 'steps__item'} onClick={this.onStepsClick.bind(this, pageId)}>{index}</li>;
        });
        return (
            <div>
                <ul className="steps">
                    <li className="steps__item steps__label">steps</li>
                    { list }
                </ul>
                <div className="steps__loader"><span className="steps__loader__load" style={this.calcProgressBar()} /></div>
            </div>
        );
    }
}

PagesCounter.propTypes = {
    mode: PropTypes.string.isRequired,
    activeId: PropTypes.number.isRequired,
    pagesList: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => ({
    mode: state.app.mode,
    activeId: state.pages.activeId,
    pagesList: state.pages.list,
    results: state.results,
    firstEmptyPage: getFirstPageWithEmptyResults(state),
});

const mapDispatchToProps= (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PagesCounter);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/PagesCounter.jsx